class e {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(o, t) {
    this.property = o, this.attribute = t;
  }
}
e.prototype.space = null;
e.prototype.boolean = !1;
e.prototype.booleanish = !1;
e.prototype.overloadedBoolean = !1;
e.prototype.number = !1;
e.prototype.commaSeparated = !1;
e.prototype.spaceSeparated = !1;
e.prototype.commaOrSpaceSeparated = !1;
e.prototype.mustUseProperty = !1;
e.prototype.defined = !1;
export {
  e as Info
};
//# sourceMappingURL=info.js.map
